<template>
  <div class="notification">
    <v-row class="pa-0 ma-0 notification__header">
      <v-col cols="auto" class="ma-0">
        お知らせ
      </v-col>
    </v-row>

    <div class="notification__area">
      <!-- お知らせが存在する場合 -->
      <template v-if="notifications.length !== 0">
        <v-list class="pa-0" >
          <!-- デフォルト表示は3件まで -->
          <v-list-item-group
            v-model="notificationId"
          >
            <v-list-item
              v-for="notification in notifications.slice(0, 3)"
              :key="notification.id"
              :value="notification.id"
              class="notification__item"
            >

              <v-list-item-content>
                <v-list-item-title :class="titleClass(notification)" v-text="notification.title"></v-list-item-title>
                <v-list-item-subtitle :class="subTitleClass(notification)" v-text="convertTextFromHtml(notification.message)"></v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action>
                <v-list-item-action-text v-text="notification.start_at" />
                <template v-if="notification.id !== 0">
                  <v-chip v-if="notification.readed" class="chip" small>既読</v-chip>
                  <v-chip v-else dark class="chip chip-not-readed" color="#ed8077" small>未読</v-chip>
                </template>
              </v-list-item-action>

            </v-list-item>
          </v-list-item-group>
        </v-list>

        <!-- 4件目以降は全て表示が押されてから表示する -->
        <v-expansion-panels
          v-model="showMore"
          flat
        >
          <v-expansion-panel>
            <v-expansion-panel-content style="padding:none !important" class="pa-0 ma-0">
              <v-list-item-group
                v-model="notificationId"
              >
                <v-list-item
                  v-for="notification in notifications.slice(3)"
                  :key="notification.id"
                  :value="notification.id"
                  class="notification__item"
                >
                  <v-list-item-content>
                    <v-list-item-title :class="titleClass(notification)" v-text="notification.title"></v-list-item-title>
                    <v-list-item-subtitle :class="subTitleClass(notification)" v-html="notification.message"></v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-action>
                    <v-list-item-action-text v-text="notification.start_at" />
                    <v-chip v-if="notification.readed" class="chip" small>既読</v-chip>
                    <v-chip v-else dark class="chip chip-not-readed" color="#ed8077" small>未読</v-chip>
                  </v-list-item-action>

                </v-list-item>
              </v-list-item-group>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <!-- 4件以上ある場合は「すべて表示」ボタンを表示する -->
        <div class="notification__action" v-if="notifications.length > 3">
          <v-row>
            <v-spacer></v-spacer>
            <v-col class="pa-0 pr-3" cols="auto">
              <v-btn color="primary" text @click="changeShowCount">{{btnText}}</v-btn>
            </v-col>
          </v-row>
        </div>
      </template>

      <!-- お知らせが無い場合 -->
      <!-- mouted前(=お知らせ一覧APIが叩かれる前にも表示されてしまうため v-else-if文を使用)-->
      <template v-else-if="isMounted">
        <p class="pt-6 pa-4 notification__none-text"> 現在お知らせはありません </p>
      </template>
    </div>

    <!-- お知らせ詳細ダイアログ -->
    <v-dialog
      v-model="detailDialog"
      max-width="30%"
      transition="slide-y-transition"
    >
      <v-card ref="dialog" v-if="detailNotification">

        <v-card-title  class="card-title grey lighten-2">
          {{detailNotification.title}}
        </v-card-title>

        <v-card-text
          class="mt-4"
          v-html="detailNotification.message">
        </v-card-text>

        <v-btn text class="mx-4 px-2 text-lowercase filename" v-if="detailNotification.filename" @click="download">
          <v-icon dark color="primary">
            mdi-file-send-outline
          </v-icon>{{detailNotification.filename}}
        </v-btn>

        <v-divider/>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            dark
            small
            @click.stop="detailDialog = false"
          >
            閉じる
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { saveAs } from 'file-saver'

export default {

  data: () => ({
    // moutedが完了したかのフラグ
    isMounted: false,
    // お知らせ一覧
    notifications: [],
    // 一部（3件）表示；filter, 全件表示：all
    showOption: 'filter',
    // お知らせdialog系の変数
    notificationId: undefined,
    detailDialog: false,
    detailNotification: null,

    showMore: null,
  }),

  async mounted() {
    await this.getNotifications()
    this.isMounted = true
  },

  computed: {
    btnText() {
      if (this.showMore === 0) return '閉じる'
      else return '全て表示'
    }
  },

  watch: {
    // お知らせがクリックされた時に実行させる処理
    async notificationId(now) {
      if (now === undefined) return
      this.detailNotification = this.notifications.find(notification => notification.id === now)
      this.detailDialog = true;
      // 未読のお知らせがクリックされた場合、「既読にするAPI」を実行
      if (this.detailNotification.readed || this.detailNotification.id == 0) return
      await this.$axios.put(`/api/v1/teacher/notifications/${this.detailNotification.id}/read`)
      this.detailNotification.readed = true
    },
    detailDialog(now) {
      // お知らせ詳細ダイアログが閉じられたら、選択中のお知らせを解除する
      if (now) return
      this.detailNotification = null
      this.detailDialog = null
      this.notificationId = undefined
    }
  },

  methods: {
    // 先生_お知らせ一覧取得API
    async getNotifications() {
      const res = await this.$axios('/api/v1/teacher/notifications')
      this.notifications = res.data

      // 岐阜県の無料アカウントの場合は残りダウンロード回数のお知らせを先頭に追加
      const prefectureCode = this.$store.state.user.schoolData?.prefecture_code
      if (this.$store.getters['user/isFree'] && !this.$store.state.user.isDemo && prefectureCode === 21) {
        this.notifications.unshift({
          id: 0,
          title: '残りダウンロード回数のお知らせ',
          message: `あと残り${this.$store.state.user.remainingDownloadCount}回ダウンロード可能です。お問い合わせいただく場合は、弊社特約店までご連絡ください`,
          start_at: new Date().toISOString().split('T')[0],
          readed: false
        })
      }
    },
    changeShowCount() {
      if (this.showMore !== 0) this.showMore = 0
      else this.showMore = null
    },
    convertTextFromHtml(html) {
      return html.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g,'')
    },
    async download() {
      const res = await this.$axios(this.detailNotification.file_path, {responseType: 'blob'})
      const blob = new Blob([res.data], { type: res.data.type })

      saveAs(blob, this.detailNotification.filename)
    },
    titleClass(notification) {
      return {
        'title': true,
        'title--attention': notification.id === 0
      }
    },
    subTitleClass(notification) {
      return {
        'sub-title': true,
        'sub-title--attention': notification.id === 0 && this.$store.state.user.remainingDownloadCount === 0
      }
    }
  },
}
</script>

<style lang="stylus" scoped>
.notification
  border-radius 3px
  box-shadow 0px 0px 2px 0px #808080

  &__area
    background-color white
    border-radius 0px 0px 3px 3px
    min-height 70px

  &__fixed-message
    padding 12px 16px
    margin 0
    font-size 14px
    border-bottom 1px solid #cacaca

  &__header
    width 100%
    height 50px
    color white
    padding 10px
    border-radius 3px 3px 0px 0px
    vertical-align middle
    background-color #2a5594

  &__item
    border-bottom 1px solid #cacaca

  &__action
    height 36px

  &__none-text
    font-size 14px !important

.content-upper
  display flex

.card-title
  font-size 18px !important

.title
  font-size 15px !important

  &--attention
    color red
    font-weight bold
    font-size 16px !important

.sub-title
  &--attention
    color red !important

.chip
  margin-top 6px
  height 21px
  box-shadow 0px 0px 2px 0px #535353
  font-size 11px !important

  &-not-readed
    font-weight bold

.message
  margin-top 5px
  max-width 750px !important
  font-size 12px !important

.filename
  font-size 15px !important
  letter-spacing normal

</style>
